import React from 'react'
import axios from '~/data/http/axios';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { connect } from 'react-redux';
import * as siteMaster from '~/data/actions/siteActions'; //now we can use user actions here
import i18n from '~/i18n';


//CONNECT TO STORE
@connect((store) => {
    return { user: store.user, permissionStore: store.permission, siteMaster: store.siteMaster }
})

export default class SalesMateAddAccount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            appData: {},
            isLoaded: false,
            sessionKey: "",
            keyError: ""
        };

        this.getApp = this.getApp.bind(this);
        this.save = this.save.bind(this);
        this.disconnect = this.disconnect.bind(this);
    }

    componentDidMount() {
        this.getApp();
    }

    getApp() {
        var self = this;
        axios.get("/application/account/app/38").then(_theApp => {
            self.setState({ appData: _theApp.data.Application, isLoaded: true })
        })
    }

    save() {
        var self = this;
        var appData = this.state.appData;
        appData.sessionKey = this.state.sessionKey;
        axios.post('/application/salesmate/addKey', appData).then(() => {
            self.props.history.push('/cp/company/integrations/apps/salesmate/changeFields')
        }).catch(err => {
            self.setState({ keyError: err.data.error })
        })
    }

    disconnect() {

        var self = this;
        axios.delete('/application/account/' + this.state.appData.id).then(res => {
            self.props.history.push('/cp/company/integrations?show=38')
        })

    }
    render() {

        if (this.state.isLoaded == false) return <div> <LoadingIcons iconType="2" /></div>

        return <div>
            <Paper>
                <Row>
                    <Column xs={12}>
                        <h4 className="mar-b25">Connect to Salesmate</h4>
                        <p><strong>Before we can get started, we need to connect to your Salesmate account.</strong></p>
                        <p>Please visit <a href={'https://' + this.state.appData.appSettings.crmurl + '/#/app/user/accesskey'} target="_blank">{this.state.appData.appSettings.crmurl + '/#/app/user/accesskey'}</a> and copy your <strong>Session Key</strong> into the box below</p>
                    </Column>
                    <Column xs={12} margin={0} className="mar-b25">
                        <TextInput label="Your Salesmate Session Key" placeholder="" value={this.state.sessionKey} onChange={(event) => { this.setState({ sessionKey: event.target.value }) }} error={this.state.keyError} />
                    </Column>

                    <Column xs={6}>
                        <Button text="Back" onClick={this.disconnect} />
                    </Column>
                    <Column xs={6} className="end-xs">
                        <Button disabled={!this.state.sessionKey || !this.state.sessionKey.length} className="button-primary" text="Save and Continue" onClick={this.save} />
                    </Column>
                </Row>
            </Paper>

        </div >

    };


};


